import { plural } from '@cian/utils/lib/shared/plural';
import { mergeStyles } from '@cian/utils';
import { IUnderground } from '@cian/api-models/search-offers/v2/types';
import * as React from 'react';

import { UndergroundIcon } from '../underground_icon';
import { isDefined } from '../../../utils/isDefined';

const styles = require('./index.css');

export interface IUndergroundProps {
  url: string;
  locationId?: number;
  underground: IUnderground;
  onClick?(e: React.MouseEvent<HTMLAnchorElement>): void;
  hideDot?: boolean;
}

const INTERPUNCT = '\u22C5';

export const Underground: React.StatelessComponent<IUndergroundProps> = ({
  url,
  locationId,
  underground,
  onClick,
  hideDot,
}) => {
  const {underConstruction, releaseYear} = underground;

  return (
    <div {...mergeStyles(styles['underground-container'], hideDot && styles['without-dot'])}>
      <a
        className={styles['underground-link']}
        href={url}
        target="_blank"
        onClick={onClick}
      >
        <div className={styles['icons']}>
          <UndergroundIcon
            width={16}
            height={16}
            color={`#${underground.lineColor}`}
            regionId={locationId}
          />
        </div>
        <div {...mergeStyles(styles['underground-name'], underConstruction && styles['color-grey'])}>
          {underground.name}
        </div>
      </a>
      {underConstruction && <span className={styles['constructing']}>откроется в {`${releaseYear}`}</span>}
      {!hideDot && INTERPUNCT}
      {
        isDefined(underground.time) && underground.time > 0 &&
        <div className={styles['remoteness']}>
          {underground.time}&nbsp;
          {plural(underground.time, ['минута', 'минуты', 'минут'])}&nbsp;
          {underground.transportType === 'walk' ? 'пешком' : 'на транспорте'}
        </div>
      }
    </div>
  );
};
